<template>
  
  <div class="slider-container">
      <transition name="fade" mode="out-in">
  <img
    v-if="imagenes.length"
    :key="currentIndex"
    :src="imagenes[currentIndex]"
    class="slider-image"
  />
</transition>
      
      <!-- Indicadores -->
      <div class="indicadores">
        <span
          v-for="(img, index) in imagenes"
          :key="index"
          :class="{ activo: index === currentIndex }"
        ></span>
      </div>
    </div>
  </template>
  
  <script>
  import { Session } from "../controllers/DataController.js";
 
import { POSEncFunctions } from "../controllers/POSController.js";

  export default {
    name: "PromocionesFullScreen",
  
    data() {
      return {
        currentIndex: 0,
        loading: false,
      session: new Session(),
      ordenFunctions: new POSEncFunctions(this.$config.api_backend_route),
        imagenes: [],
        intSucursal:this.$route.params.id,
        objtbImagenes:[],
        intervalo: null
      };
    },
    
  
  async mounted() {
    console.log(this.intSucursal)
    console.log( this.$route.params.id)
  await this.cargarImagenes();

  if (this.imagenes.length > 0) {
    this.iniciarSlider();
  }
  console.log(this.intSucursal)
    console.log( this.$route.params.id)
  
},
  
    methods: {
      async cargarImagenes() {
  try {
    this.loading = true;

   
    const data = await this.ordenFunctions.dataImagenes(this.intSucursal);

    this.objtbImagenes = data;

    this.imagenes = data.map(x => x.strImagen);

    console.log(this.imagenes);
  }
  catch (error) {
    console.error(error);
  }
  finally {
    this.loading = false;
  }
},


iniciarSlider() {
  if (!this.imagenes.length) return;

  this.intervalo = setInterval(() => {
    this.currentIndex++;

    if (this.currentIndex >= this.imagenes.length) {
      this.currentIndex = 0;
    }
  }, 10000); // cambia cada 5 segundos
      }
    }
  };
  </script>
  
  <style scoped>
  .slider-container {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;

  background-image: url('/images/fondo.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.slider-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
  
  /* Animación */
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 1s;
  }
  
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
  
  /* Indicadores */
  .indicadores {
    position: absolute;
    bottom: 25px;
    width: 100%;
    display: flex;
    justify-content: center;
    gap: 10px;
  }
  
  .indicadores span {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: rgba(255,255,255,0.5);
    transition: 0.3s;
  }
  
  .indicadores .activo {
    background: white;
    transform: scale(1.2);
  }
  </style>